import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckbox = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 1.5H18V-1.5H6V1.5ZM22.5 6V18H25.5V6H22.5ZM18 22.5H6V25.5H18V22.5ZM1.5 18V6H-1.5V18H1.5ZM6 22.5C3.51472 22.5 1.5 20.4853 1.5 18H-1.5C-1.5 22.1421 1.85786 25.5 6 25.5V22.5ZM22.5 18C22.5 20.4853 20.4853 22.5 18 22.5V25.5C22.1421 25.5 25.5 22.1421 25.5 18H22.5ZM18 1.5C20.4853 1.5 22.5 3.51472 22.5 6H25.5C25.5 1.85786 22.1421 -1.5 18 -1.5V1.5ZM6 -1.5C1.85786 -1.5 -1.5 1.85786 -1.5 6H1.5C1.5 3.51472 3.51472 1.5 6 1.5V-1.5Z",
		fill: "#D9DEEB"
	})
});
const ForwardRef = forwardRef(SvgCheckbox);
export default ForwardRef;
